export const nflTeamNameIDArrayMap = new Map([
    [323, 'atlanta-falcons'],
    [324, 'buffalo-bills'],
    [325, 'houston-texans'],
    [326, 'chicago-bears'],
    [327, 'cincinnati-bengals'],
    [329, 'cleveland-browns'],
    [331, 'dallas-cowboys'],
    [332, 'denver-broncos'],
    [334, 'detroit-lions'],
    [335, 'green-bay-packers'],
    [336, 'tennessee-titans'],
    [338, 'indianapolis-colts'],
    [339, 'kansas-city-chiefs'],
    [341, 'las-vegas-raiders'],
    [343, 'los-angeles-rams'],
    [345, 'miami-dolphins'],
    [347, 'minnesota-vikings'],
    [348, 'new-england-patriots'],
    [350, 'new-orleans-saints'],
    [351, 'new-york-giants'],
    [352, 'new-york-jets'],
    [354, 'philadelphia-eagles'],
    [355, 'arizona-cardinals'],
    [356, 'pittsburgh-steelers'],
    [357, 'los-angeles-chargers'],
    [359, 'san-francisco-49ers'],
    [361, 'seattle-seahawks'],
    [362, 'tampa-bay-buccaneers'],
    [363, 'washington-football-team'],
    [364, 'carolina-panthers'],
    [365, 'jacksonville-jaguars'],
    [366, 'baltimore-ravens'],
])
